import { render, staticRenderFns } from "./campaign-selector.vue?vue&type=template&id=12640ec4&scoped=true"
import script from "./campaign-selector.vue?vue&type=script&lang=js"
export * from "./campaign-selector.vue?vue&type=script&lang=js"
import style0 from "./campaign-selector.vue?vue&type=style&index=0&id=12640ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12640ec4",
  null
  
)

export default component.exports